import APIClient from '../apiClient';

// Resolve the current user from the httpOnly cookie. 200 → user; 401 → null
// (logged out). Any other error also resolves to null so a transient failure
// degrades to "logged out" rather than throwing during app hydration.
export const fetchMe = async () => {
  try {
    const res = await APIClient.get('/authentication/me');
    return res.data?.data?.user || null;
  } catch (e) {
    return null;
  }
};
